import { lazy, Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const userSearchSchema = z.object({
  q:      z.string().optional(),
  role:   z.string().optional(),
  status: z.enum(['active', 'suspended']).optional(),
  page:   z.number().int().min(1).optional().default(1),
});

const UsersScreen = lazy(() =>
  import('../screens/Users/UsersScreen').then(m => ({ default: m.UsersScreen })),
);

export const Route = createFileRoute('/users/')({
  validateSearch: userSearchSchema,
  component: UsersIndexPage,
});

function UsersIndexPage() {
  return (
    <Suspense fallback={<div style={{ padding: 32, color: 'var(--lca-gray-500)', fontSize: 13 }}>Loading…</div>}>
      <UsersScreen />
    </Suspense>
  );
}
